/**
 * Modulo de Catalogo: aplicacoes, ferramentas e acoes.
 *
 * E o vocabulario da permissao -- so existe permissao para o que esta
 * cadastrado aqui. Por isso esta tela e a primeira a ser usada num ambiente
 * novo: e por ela que o proprio accounts se cadastra.
 */
export const nav = {
    permissao: 'accounts.catalogo:ver',
    section: 'Resources',
    title: 'Catalog',
    icon: 'apps',
    route: '/catalogo',
    accordion: false,
};

export default [
    {
        path: '/catalogo',
        name: '/catalogo',
        component: () => import('./pages/AplicacoesListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.catalogo:ver' },
    },
    {
        // Fica dentro do catalogo, e nao em modulo proprio, porque so faz
        // sentido depois de existirem aplicacoes, ferramentas e acoes.
        path: '/catalogo/menu',
        name: 'catalogo-menu',
        component: () => import('./pages/MenuPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.catalogo:editar' },
    },
    {
        path: '/catalogo/nova',
        name: 'aplicacao-nova',
        component: () => import('./pages/AplicacaoPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.catalogo:criar' },
    },
    {
        path: '/catalogo/editar/:id',
        name: 'aplicacao-editar',
        component: () => import('./pages/AplicacaoPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.catalogo:editar' },
    },
];
